import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import EventDetail from "../../components/manage-event-detail/event-detail";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { handleAuthError } from "../../utils/authUtils";

function ManageEventsDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [event, setEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchEventDetail = async () => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.error("Session expired. Please sign in again.");
      navigate("/");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}${API_ENDPOINTS.NONPROFIT_UPDATE_EVENT}?eventId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json().catch(() => null);
      const statusCode = result?.statusCode ?? response.status;

      // Check for auth errors first
      if (handleAuthError(result, response.status, dispatch)) {
        return; // Auth error handled, redirect will happen
      }

      if (!response.ok || statusCode >= 400) {
        const message = result?.message || "Failed to load event details";
        throw new Error(message);
      }

      setEvent(result?.data || null);
    } catch (error) {
      console.error("Fetch event detail error:", error);
      toast.error(error?.message || "Failed to load event details");
      setEvent(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      // Always fetch fresh from API so analytics counts are up to date
      fetchEventDetail();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (isLoading) {
    return (
      <div className="w-[90%] lg:w-[95%] mx-auto my-8">
        <div className="animate-pulse space-y-6">
          <div className="h-8 bg-gray-200 rounded w-1/3"></div>
          <div className="h-64 bg-gray-200 rounded"></div>
          <div className="space-y-4">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <EventDetail event={event} />
    </div>
  );
}

export default ManageEventsDetail;
